export default __webpack_public_path__ + "static/media/frontend.22f68ba5.jpg";